<template>
    <div class="jobDetail coursesDetail  Regular" :class="{'coursesDetailPC':$store.state.innerWidth>768}">
        
        <div class="assistant"  >
            <Breadcrumbs></Breadcrumbs>
            <div class="a-content pad-15 row courses-content" >
                <div class="coursesPC">
                   <h2 class="col-sm-10 Bold coursesTitle padLeft-0">{{$store.getters.getObject(course.langMap).title}}</h2>
                   <div class="courseTip col-sm-10"  v-if="$store.getters.getObject(course.langMap).description" v-html="$store.getters.getObject(course.langMap).description">
                   </div>
                   <div class="col-sm-6 coursesQR padLeft-0">
                       <div class="item-table pad-5" >
                            <div class="tdcell ">
                                <p v-if="course.qrNo" style="padding-bottom:15px">{{$t('message.QR number:')}} {{course.qrNo}}</p>
                                <p v-if="course.dataSource=='qr'&&course.isCef" class=" itemContent1">
                                    <span>{{$t('message.CEF')}}</span>
                                    <i class="icon-i pad-l-10 pointer" v-on:click="getCEFInfo()"></i>
                                </p>
                                <p v-if="course.dataSource=='qr'" class=" itemContent1">
                                    <span>{{$t('message.QR Courses')}}</span>
                                    <i class="icon-i pad-l-10 pointer" v-on:click="getQRInfo()"></i> 
                                </p>
                                <p v-if="course.dataSource=='edx'" class=" itemContent1">
                                    <span>{{$t('message.MOOC Courses')}}</span>
                                    <i class="icon-i pad-l-10 pointer" v-on:click="getMOOCInfo()"></i> 
                                </p>
                                <p v-if="course.dataSource=='edx'" class=" itemContent1">
                                    <span>{{$t('message.EL')}}</span> 
                                </p>
                            </div>
                       </div>
                   </div>
                </div>
            </div>
            <div class="imgGroup" v-if="$store.state.innerWidth>768">
                <img class="img1 noSelect" src="../images/deco-21.png" />
                <img class="img2 noSelect" src="../images/deco-17.png" />
                <img class="img3 noSelect" src="../images/deco-10.png" />
                <img class="img4 noSelect" src="../images/deco-18.png" />
            </div>
        </div>
        <div class="description courses-content" >
            <div class="coursesPC pad-15"  >
                <div class="col-sm-6 pad-r-40 pad-t-100 course-item"  v-if="$store.getters.getObject(course.langMap).grantingBody">
                    <div class="item-table" ref='item1'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Course Provider')}}</h3>
                             <p class="circle itemContent" v-for="(grantingBody,index) in $store.getters.getObject(course.langMap).grantingBody">{{grantingBody}}</p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/school.png" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 pad-l-40 pad-t-100 course-item"  v-if="$store.getters.getObject(course.langMap).areaOfStudy">
                    <div class="item-table" ref='item2'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Area of Study')}}</h3>
                            <p class="circle itemContent" v-for="(areaOfStudy,index) in $store.getters.getObject(course.langMap).areaOfStudy">{{areaOfStudy}}</p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/area of study.png" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 pad-r-40 pad-t-100 course-item"   v-if="course.dataSource=='qr'&&course.learningMode">
                    <div class="item-table" ref='item3'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Learning mode')}}</h3>
                            <p class="circle itemContent" 
                            v-for="mode in course.learningMode" 
                            v-if="$store.getters.getTrim(mode)=='FT'||$store.getters.getTrim(mode)=='PT'||$store.getters.getTrim(mode)=='DL'||$store.getters.getTrim(mode)=='EL'||$store.getters.getTrim(mode)=='Not Applicable'" 
                            >
                                {{$t('message.'+ $store.getters.getTrim(mode) +'')}}
                            </p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/learnig mode.png" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 pad-l-40 pad-t-100 course-item"   v-if="course.dataSource=='edx'&&course.pacingType">
                    <div class="item-table" ref='item4'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Pace of learning')}}</h3>
                            <p class="circle itemContent">{{course.pacingType[0] | capitalize}}</p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/Flat icon-45 (1).png" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 pad-l-40 pad-t-100 course-item"   v-if="course.level&&course.subDataSource != 'Microsoft'">
                    <div class="item-table" ref='item5'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Level')}}</h3>
                            <p class="circle itemContent"><span v-if="course.dataSource=='qr'">{{$t('message.QF level')}}</span>{{course.level}}</p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/Level.png" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 pad-l-40 pad-t-100 course-item"   v-if="course.microsoftLevel&&course.subDataSource == 'Microsoft'">
                    <div class="item-table" ref='item5'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Level')}}</h3>
                            <p class="circle itemContent" v-for="(areaOfStudy,index) in course.microsoftLevel">{{titleCase(areaOfStudy)}}</p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/Level.png" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 pad-l-40 pad-t-100 course-item"   v-if="course.dataSource=='edx'&&course.minEffort">
                    <div class="item-table" ref='item6'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Effort')}}</h3>
                            <p class="circle itemContent">{{$t('message.EffortTip1')}}{{course.minEffort[0]}}<span v-if="course.minEffort[0]&&course.maxEffort[0]">-</span>{{course.maxEffort[0]}}{{$t('message.EffortTip2')}}</p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/Flat icon-46 (1).png" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 pad-l-40 pad-t-100 course-item"   v-if="course.dataSource=='edx'&&course.weeksToComplete">
                    <div class="item-table" ref='item7'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Length')}}</h3>
                            <p class="circle itemContent">{{course.weeksToComplete[0]}} {{$t('message.week(s)')}}</p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/Flat icon-47 (1).png" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 pad-l-40 pad-t-100 course-item"   v-if="course.dataSource=='edx'&&course.subDataSource == 'Microsoft'">
                    <div class="item-table" ref='item7'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Length')}}</h3>
                            <p class="circle itemContent">
                                <span v-show="course.durationInHour">
                                    {{course.durationInHour}} {{$t('message.hour')}}<span v-show="course.durationInHour>1">{{$t('message.s')}} </span> 
                                </span> 
                                <span v-show="course.durationInMinutes">
                                    {{course.durationInMinutes}} {{$t('message.min')}}<span v-show="course.durationInMinutes>1">{{$t('message.s')}}</span>
                                </span>
                            </p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/Flat icon-47 (1).png" />
                        </div>
                    </div>
                </div>
            </div>
            <div class=" coursesPC pad-15" v-if="$store.getters.getObject(course.langMap).requirements">
                <div class="col-sm-12 pad-t-100 padLeft-0 padRight-0"  v-if="course.dataSource=='qr'">
                   <h3 class="Bold desc-title learnTitle">{{$t('message.Requirements')}}</h3>
                   <p class="circle itemContent" style="white-space: pre-line" v-html="$store.getters.getObject(course.langMap).requirements"></p>
                </div>
                <div class="col-sm-12 pad-t-100 padLeft-0 padRight-0"  v-if="course.dataSource=='edx'">
                   <h3 class="Bold desc-title learnTitle">{{$t('message.What youll learn')}}</h3>
                   <div class="learnHtml" v-html="course.outcome[0]"></div>
                </div>
                <div class="col-sm-12 pad-t-100 padLeft-0 padRight-0"  v-if="course.dataSource=='edx'">
                   <h3 class="Bold desc-title learnTitle">{{$t('message.Prerequisites')}}</h3>
                   <div class="Prerequisites" v-html="$store.getters.getObject(course.langMap).requirements"></div>
                </div>
            </div>
        </div>
        <div class="courses-content " >
            <div class="  coursesPC shareContent">
                <div class="center pad-tb-50 learnMore" v-if="course.marketingUrl">
                    <div class="btn btn-primary" v-on:click="learnMore(course.marketingUrl[0])" role="button" :aria-label="$t('message.Go to course page')">
                       <a href="javascript:;" style="color: inherit">{{$t('message.Go to course page')}}</a>
                    </div>
                </div>
                <!--div class="References Bold"><span>{{$t('message.To know more')}}</span><i class="icon-arrow-right"></i></div-->
                <ShareBar v-if="showShareBar"></ShareBar>
            </div>
        </div>
        <div class="" v-if="courses.qrCourse.length>0||courses.edxCourse.length>0">
            <div class=" courses-content">
                <div class="  coursesPC">
                    <div class="mainColor box-img-bg"  :class="{'padding-30':swiperPedding}">
                        <h2 class="Bold relatedCourses">{{$t('message.RelatedCourses')}} 
                        <img class="noSelect" src="../images/deco1.png" /></h2>
                    </div>
                    <SwiperQRcourses :course-list="courses.qrCourse" v-if="select==1&&courses.qrCourse.length>0"></SwiperQRcourses>
                    <SwiperMOOCcourses :course-list="courses.edxCourse" v-if="select==2&&courses.edxCourse.length>0"></SwiperMOOCcourses>
                    <div class="center pad-tb-50">
                        <div class="btn btn-primary" role="button" :aria-label="$t('message.View all qualifications')" v-if="select==1&&courses.qrCourse.length>5||select==2&&courses.edxCourse.length>5" @click="viewAllEvent()">
                           <a href="javascript:;" style="color: inherit">{{$t('message.View all qualifications')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="occ-discover">
              <div class="courses-placeImg">
                <div class="occ-deco-12">
                  <img class="noSelect" src="../images/deco-12.png" />
                </div>
              </div>
            <div class="occ-discover-text SemiBold">
                <span>{{$t('message.Discover more career resources')}}</span>
            </div>
            <div class="center pad-tb-50 allBtn" @click="goRsources">
                <div class="btn btn-primary" role="button" :aria-label="$t('message.FInd out more')">
                    <a href="javascript:;" style="color: inherit">{{$t('message.FInd out more')}}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import SwiperQRcourses from '@/components/SwiperQRcourses.vue'
    import SwiperMOOCcourses from '@/components/SwiperMOOCcourses.vue'
    import Breadcrumbs from '@/components/Breadcrumbs'
    import ShareBar from '@/components/ShareBar.vue'
    import { EventBus } from "@/javascripts/eventBus.js";
    export default {
        name:"coursesDetail",
    data() {
        return {
            select:1,
            course:{},
            courses:{
                qrCourse:[],
                edxCourse:[]
            },
            swiperPedding:false,
            showShareBar:false,
        }
    },   
    props: ["logGaEvent"],
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    computed:{
        innerwidth(){
          return this.$store.state.innerWidth;
        },
        _language(){
          return this.$store.state.language
        },
        key(){
            return this.$route.params.key;
        }
    },
    watch:{
        innerwidth (news,old) {
          this.checkWidth();
          this.setItemHeight();
        },
        _language:{
            handler: function(val, oldVal) {
                let that = this;
                if(this.$route.path.indexOf("coursesDetail")>0){
                    var breadcrumbs = this.$route.meta.breadcrumbs.find(
                        b => b.to.indexOf("coursesDetail")>0
                    );

                    // this.$router.push({query: {lang: val,name:this.$store.getters.replaceEvent(this.$store.getters.getObject(this.course.langMap).title)}})
                    let key = ""
                    if (this.course.dataSource == 'edx') {
                        key = this.course.key
                    } else {
                        key = this.course.id
                    }
                    key = encodeURIComponent(key)
                    if (breadcrumbs) {
                        breadcrumbs.text = this.$store.getters.getObject(this.course.langMap).title;
                        document.title = this.$store.state.mate.title =  this.$store.getters.getObject(that.course.langMap).title + this.$i18n.t("message.Courses_title");
                        this.$store.state.mate.description =  this.$i18n.t("message.Courses_desc");
                        this.$store.state.mate.keywords =  this.$i18n.t("message.Courses_keywords");
                        // if(this.$store.getters.getObject(this.course.langMap).description){
                        //     this.$store.state.mate.description = this.$store.getters.getObject(this.course.langMap).description;
                        // }
                        breadcrumbs.to = "/coursesDetail/"+ this.course.dataSource + "/" + key;
                    }
                }
                this.setItemHeight();
            },
            deep: true
        },
        key:{
            handler: function(val, oldVal) {
                if(this.key){
                    this.init();
                }
            },
            deep: true
        }
    },
    components: {
        SwiperQRcourses,
        Breadcrumbs,
        ShareBar,
        SwiperMOOCcourses
    },
    methods:{
        goRsources:function(){
            this.logGaEvent('userClick','courseDetail',"goResources")
            this.$router.push({ path: "/resources" , query:{lang:this.$store.state.language}});
            window.scrollTo(0, 0);
        },
        getCoursesList:function(key){
          let that = this;
          this.select = 1;
          that.api.getDetailLinkCourse({
              "key": key,
          }, function(data) {
              that.courses = data.result;
              for(let i=0;i<that.courses.qrCourse.length;i++){
                  if(that.courses.qrCourse[i].learningMode){
                      that.courses.qrCourse[i].learningMode = that.courses.qrCourse[i].learningMode.split(",")
                  }
              }
              for(let i=0;i<that.courses.edxCourse.length;i++){
                  if(that.courses.edxCourse[i].learningMode){
                      that.courses.edxCourse[i].learningMode = that.courses.edxCourse[i].learningMode.split(",")
                  }
              }
              if(that.courses.qrCourse.length==0&&that.courses.edxCourse.length>0){
                that.select = 2;
              }
          })
        },
        viewAllEvent:function(){
            this.$store.state.formData.courseKey = this.$route.params.key;
            if(this.select==1){
                this.$store.state.formData.coursesType = 3;
            }else if(this.select ==2){
                this.$store.state.formData.coursesType = 4;
            }
            this.logGaEvent('userClick','courseDetail',"ReratedCourses")
            this.$router.push({ path: '/ReratedCoursesT' , query:{lang:this.$store.state.language}});
        },
        checkWidth:function(){
          if(this.$store.state.innerWidth>=1345){
              this.swiperPedding = false;
          }else if(this.$store.state.innerWidth >= 1080){
              this.swiperPedding = true;
          }else if(this.$store.state.innerWidth >= 815){
              this.swiperPedding = true;
          }else{
              this.swiperPedding = false;
          }
        },
        setItemHeight:function(){
            var that = this;
            if(this.$store.state.innerWidth<768) return;
            setTimeout(function(){
                var height=0;
                for(var i=0;i<7;i++){
                    if(that.$refs['item'+(i+1)]){
                        that.$refs['item'+(i+1)].style.height = height+'px';
                    }
                    if(that.$refs['item'+(i+1)]&&that.$refs['item'+(i+1)].offsetHeight>height){
                        height = that.$refs['item'+(i+1)].offsetHeight
                    }
                    if(that.$refs['item'+(i+1)]){
                        that.$refs['item'+(i+1)].style.height = height+'px';
                    }
                }
            })
            
        },
        init:function(){
            let postData={}
            var that=this
            // localStorage.setItem('sign', 2);
            // if(this.$route.params.dataSource=="edx"){
            postData.key=decodeURIComponent(this.$route.params.key)
            // }else{
            //     postData.id=this.$route.params.key
            // }
            this.$store.state.selectMenu = 4;
            this.checkWidth();
            this.getCoursesList(decodeURIComponent(this.$route.params.key));
            this.showShareBar = false;
            this.api.getCourseDetail(postData, function(data) {
                that.course=data.result;
                if(that.course.subDataSource == 'Microsoft'){
                    that.course.durationInHour = Math.floor(that.course.durationInMinutes/60);
                    that.course.durationInMinutes = that.course.durationInMinutes%60;
                }
                if(that.course.learningMode){
                    that.course.learningMode = that.course.learningMode.split(",");
                }
                that.showShareBar = true;
                if(that.$route.path.indexOf("coursesDetail")>0){
                    var breadcrumbs = that.$route.meta.breadcrumbs.find(
                        b => b.to.indexOf("coursesDetail")>0
                    );

                    let key = ""
                    if (that.course.dataSource == 'edx') {
                        key = that.course.key
                    } else {
                        key = that.course.id
                    }
                    key = encodeURIComponent(key)
                    if (breadcrumbs) {
                        breadcrumbs.text = that.$store.getters.getObject(that.course.langMap).title
                        document.title = that.$store.state.mate.title =  that.$store.getters.getObject(that.course.langMap).title + that.$i18n.t("message.Courses_title");
                        that.$store.state.mate.description =  that.$i18n.t("message.Courses_desc");
                        that.$store.state.mate.keywords =  that.$i18n.t("message.Courses_keywords");
                        // if(that.$store.getters.getObject(that.course.langMap).description){
                        //     that.$store.state.mate.description = that.$store.getters.getObject(that.course.langMap).description;
                        // }
                        breadcrumbs.to = "/coursesDetail/"+ that.course.dataSource + "/" + key;
                    }
                }
                that.setItemHeight();
            })
        },
        getCEFInfo:function(){
            var link = "<a  class='info-link mainColor ' href='"+this.$i18n.t("message.CEF_link")+"' target='_blank'>"+this.$i18n.t("message.CEF_link_text")+"</a>";
          
            var text=""
            text+="<div class='department departmentJia pad-15 '><div class='popup-content '>"+this.$i18n.t("message.CEF_text")+"</div></div>"
            text = text.replace('[link]', link);
            EventBus.$emit('showPopup', {text:text,title:this.$i18n.t("message.CEF")})
        },
        getQRInfo:function(){
            var link = "<a  class='info-link mainColor ' href='"+this.$i18n.t("message.QR_link")+"' target='_blank'>"+this.$i18n.t("message.QR_link_text")+"</a>";
          
            var text=""
            text+="<div class='department departmentJia pad-15 '><div class='popup-content '>"+this.$i18n.t("message.QR_text")+"</div></div>"
            text = text.replace('[link]', link);
            EventBus.$emit('showPopup', {text:text,title:this.$i18n.t("message.QR Courses")})
        },
        getMOOCInfo:function(){
            var text=""
            text+="<div class='department departmentJia pad-15 '><div class='popup-content '>"+this.$i18n.t("message.MOOC_text")+"</div></div>"
            EventBus.$emit('showPopup', {text:text,title:this.$i18n.t("message.MOOC Courses")})
        },
        titleCase(str) {
            var newStr = str.slice(0,1).toUpperCase() +str.slice(1).toLowerCase();
            return newStr;
        }
    }, 
    // beforeRouteLeave(to, from, next){ // 列表页面跳转到 详情页时，设置需要缓存
    //     if(to.name=='onlineMagazine'){
    //         from.meta.isUseCache = false;
    //     }
    //     next()
    // },
    activated(){
        this.$store.state.mate.width = 209;
        this.$store.state.mate.height = 209;
    },
    mounted() {
        this.$store.state.mate.width = 209;
        this.$store.state.mate.height = 209;
        window.scrollTo(0, 0);
        this.init();
        this.learnMore=function(url){
            url = url.match(/^http[s]?:\/\//) ? url : 'http://' + url;
            window.open(url)
        }
    }
}
</script>